import { Box, makeStyles } from 'vendor/material';
import { SolutionFieldEnum, SolutionFieldMap } from './sectionSchema';
import ControlledTextField from '../controlledFields/ControlledTextField';
import ControlledSingleSelectField from '../controlledFields/ControlledSingleSelectField';
import useCurrencyOptions from '../../hooks/useCurrencyOptions';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
  },
}));

const FirstPartyFormFields = ({
  fieldNamePrefix,
}: {
  fieldNamePrefix: string;
}) => {
  const classes = useStyles();

  const currency = SolutionFieldMap[SolutionFieldEnum.currency];
  const price = SolutionFieldMap[SolutionFieldEnum.price];
  const quantity = SolutionFieldMap[SolutionFieldEnum.quantity];
  const currencyOptions = useCurrencyOptions();

  return (
    <Box className={classes.wrapper}>
      <ControlledTextField
        dataId={quantity.dataId}
        name={`${fieldNamePrefix}.${SolutionFieldEnum.quantity}`}
        label={quantity.label}
        required={quantity.required}
        type="number"
      />
      <ControlledTextField
        dataId={price.dataId}
        name={`${fieldNamePrefix}.${SolutionFieldEnum.price}`}
        label={price.label}
        required={price.required}
        type="number"
        mode="numberformat"
        fixedDecimalScale
        decimalScale={2}
      />

      <ControlledSingleSelectField
        dataId={currency.dataId}
        name={`${fieldNamePrefix}.${SolutionFieldEnum.currency}`}
        label={currency.label}
        required={currency.required}
        options={currencyOptions}
      />
    </Box>
  );
};

export default FirstPartyFormFields;
